<template>
  <div>
    <fieldset>
      <legend class="text-blue ts-font-robot">
        {{ $t('expensePosting.details') }}
        <Tooltip placement="top">
          <Icon type="ios-information-circle-outline" size="17" />
          <div slot="content">
            <div class="ts-text-xs">
              {{ $t('expensePosting.details') }}
            </div>
          </div>
        </Tooltip>
      </legend>
      <div class="overflow-auto ts-max-h-40">
        <div class="table-ui-detail">
          <table>
            <thead>
              <tr>
                <th width="1%" class="ts-text-center">
                  {{ $t('no') }}
                </th>
                <th width="13%">
                  {{ $t('expensePosting.expCategory') }}
                  <span class="ts-text-red-600">*</span>
                </th>
                <th width="11%">
                  {{ $t('expensePosting.expItem') }}
                  <span class="ts-text-red-600">*</span>
                </th>
                <th width="11%">
                  {{ $t('expensePosting.product') }}
                </th>
                <th width="11%">
                  {{ $t('expensePosting.imei') }}
                </th>
                <th width="7%">
                  {{ $t('expensePosting.uom') }}
                  <span class="ts-text-red-600">*</span>
                </th>
                <th width="6%" class="ts-text-center">
                  {{ $t('expensePosting.qty') }}
                  <span class="ts-text-red-600">*</span>
                </th>
                <th width="10%">
                  {{ $t('expensePosting.amount') }}
                  <span class="ts-text-red-600">*</span>
                </th>
                <th width="9%">
                  {{ $t('expensePosting.total') }}
                  <span class="ts-text-red-600">*</span>
                </th>
                <th width="9%">
                  {{ $t('expensePosting.convertedtotal') }}
                  <span class="ts-text-red-600">*</span>
                </th>
                <th width="10%">
                  {{ $t('expensePosting.expenseBy') }}
                  <span class="ts-text-red-600">*</span>
                </th>
                <th width="10%">
                  {{ $t('expensePosting.purpose') }}
                </th>
                <th class="text-center ts-fixed ts-right-0" width="3%">
                  <a href="#" class="tw-text-white" @click.prevent="addNewItem">
                    <i class="fas fa-plus"></i>
                  </a>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="model.details == 0">
                <td colspan="13" class="ts-text-center ts-p-3 ts-space-x-1">
                  <i class="fa fa-folder-open ts-text-gray-200"></i>
                  <label class="ts-text-gray-400">
                    {{ $t('noData') }}
                  </label>
                  <div class="validate ts-text-left" v-if="errors.has('details')">
                    {{ errors.first('details') }}
                  </div>
                </td>
              </tr>
              <tr v-else v-for="(detail, index) in model.details" :key="index">
                <td class="ts-whitespace-no-wrap ts-text-center">
                  {{ index + 1 }}
                </td>
                <td class="ts-overflow-hidden ts-whitespace-no-wrap" style="max-width: 200px;min-width: 100px;">
                  {{
                    getExpenseItem(detail.exp_id)
                      ? getExpenseItem(detail.exp_id).exp_category
                      : 'N/A'
                  }}
                </td>
                <td class="ts-whitespace-no-wrap ts-overflow-hidden" style="max-width: 165px;min-width: 100px;">
                  {{
                    getExpenseItem(detail.exp_id)
                      ? getExpenseItem(detail.exp_id).exp_item
                      : 'N/A'
                  }}
                </td>
                <td class="ts-whitespace-no-wrap ts-overflow-hidden" style="max-width: 165px;min-width: 100px;">
                  <span v-if="!getProduct(detail)">N/A</span>
                  <span class="ts-whitespace-no-wrap">
                    {{
                      getProduct(detail)
                        ? getProduct(detail).product_name_en
                        : ''
                    }}
                  </span>
                </td>
                <td class="ts-whitespace-no-wrap ts-overflow-hidden" style="max-width: 165px;min-width: 100px;">
                  <span v-if="!getImei(detail)">N/A</span>
                  <span class="ts-whitespace-no-wrap">
                    {{ getImei(detail) ? getImei(detail).imei : '' }}
                  </span>
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  <a-select v-model="detail.uom_id" :options="getUnitOfMeasures(detail.exp_id)"
                    option-filter-prop="children" class="ts-w-full" placeholder="Select"
                    style="min-width: 75px;"></a-select>
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  <input v-model.number="detail.quantity" style="min-width: 70px;" type="text"
                    class="form-control ts-text-center" :class="{
                      'is-invalid': errors.has('details.' + index + '.quantity')
                    }" />
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  <ts-currency-converter-input :input_amount.sync="detail.input_unit_price"
                    :amount.sync="detail.unit_price" :input_currency_id.sync="detail.input_currency_id"
                    :currency_id.sync="detail.currency_id" :fx_rate.sync="detail.fx_rate"
                    :fx_rate_ratio.sync="detail.fx_rate_ratio" style="min-width: 120px;" />
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  <ts-currency-input v-model.number="detail.input_total" class="form-control ts-text-right"
                    style="min-width: 100px" :currency="getCurrencySign(detail.input_currency_id)"
                    :precision="getPrecision(detail.input_currency_id)" :disabled="true" />
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  <ts-currency-input v-model.number="detail.total" class="form-control ts-text-right"
                    style="min-width: 100px" :currency="getCurrencySign(detail.currency_id)"
                    :precision="getPrecision(detail.currency_id)" :disabled="true" />
                </td>
                <td class="text-center ts-whitespace-no-wrap" style="max-width: 150px;">
                  <a-select v-model="detail.expense_by" :options="employees" allowClear show-search
                    option-filter-prop="children" class="ts-w-full" placeholder="Select" :class="{
                      'is-invalid': errors.has(
                        'details.' + index + '.expense_by'
                      )
                    }"></a-select>
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  <textarea v-model="detail.purpose" class="form-control" style="min-width: 150px;width: auto"
                    placeholder="Purpose"></textarea>
                </td>
                <td class="text-center ts-sticky ts-right-0" style="background: #f7f7f7;">
                  <Tooltip placement="top" :transfer="true" :content="$t('remove')">
                    <a href="#" class="text-danger" @click.prevent="removeRow(detail)">
                      <Icon type="ios-remove-circle-outline" size="20" />
                    </a>
                  </Tooltip>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="background-color: #e3e8f1;">
                <td class="ts-whitespace-no-wrap" colspan="8">
                  <b>{{ $t('expensePosting.row') }} :
                    {{ model.details.length }}</b>
                </td>
                <td class="ts-whitespace-no-wrap ts-text-right">
                  <b>{{ $t('expensePosting.totalAmount') }} :</b>
                </td>
                <td class="ts-whitespace-no-wrap ts-text-center">
                  <ts-currency-input v-model.number="model.grand_total" class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;border:transparent;"
                    :currency="getCurrencySign(model.currency_id)" :precision="getPrecision(model.currency_id)"
                    :disabled="true" />
                </td>
                <td colspan="3"></td>
              </tr>
              <tr v-if="model.expense_type == 2 || model.advance_id">
                <td colspan="5" rowspan="2" style="
                  border-left: 1px solid transparent;
                  border-bottom: 1px solid transparent;"></td>
                <td class="ts-whitespace-no-wrap ts-text-right" colspan="2">
                  <b>{{ $t('expensePosting.advanceAmount') }} :</b>
                </td>
                <td class="ts-whitespace-no-wrap ts-text-center">
                  <ts-currency-input :value="advance_amount" class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;" :currency="getCurrencySign(model.currency_id)"
                    :precision="getPrecision(model.currency_id)" :disabled="true" />
                </td>
                <td class="ts-whitespace-no-wrap ts-text-right">
                  <b>{{ $t('expensePosting.advanceUsed') }} :</b>
                </td>
                <td class="ts-whitespace-no-wrap ts-text-center">
                  <ts-currency-input :value="amount_used" class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;" :currency="getCurrencySign(model.currency_id)"
                    :precision="getPrecision(model.currency_id)" :disabled="true" />
                </td>
                <td colspan="3"></td>
              </tr>
              <tr v-if="model.expense_type == 2 || model.advance_id">
                <td class="ts-whitespace-no-wrap ts-text-right" colspan="2">
                  <b>{{ $t('expensePosting.advanceStatus') }} :</b>
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  <a-select v-model="model.advance_status" :options="advanceStatus" option-filter-prop="children"
                    class="ts-w-full" placeholder="Select" size="small"
                    :class="{ 'is-invalid': errors.has('advance_status') }" @change="onChangeAdvanceStatus"></a-select>
                </td>
                <td class="ts-whitespace-no-wrap ts-text-right">
                  <b style="color:red">
                    {{ $t('expensePosting.reimburseAmount') }}
                    :
                  </b>
                </td>
                <td class="ts-whitespace-no-wrap ts-text-center">
                  <ts-currency-input :value="amount_due" class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;color:red" :currency="getCurrencySign(model.currency_id)"
                    :precision="getPrecision(model.currency_id)" :disabled="true" />
                </td>
                <td colspan="3"></td>
              </tr>
              <tr v-else>
                <td colspan="5" style="
                  border-left: 1px solid transparent;
                  border-bottom: 1px solid transparent;"></td>
                <td class="ts-whitespace-no-wrap ts-text-right" colspan="2">
                  <b>{{ $t('expensePosting.expenseStatus') }} :</b>
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  <a-select v-model="model.expense_status" :options="expenseStatus" option-filter-prop="children"
                    class="ts-w-full" placeholder="Select" size="small" disabled
                    :class="{ 'is-invalid': errors.has('expense_status') }"></a-select>
                </td>
                <td class="ts-whitespace-no-wrap ts-text-right">
                  <b style="color:red">
                    {{ $t('expensePosting.expenseAmount') }}
                    :
                  </b>
                </td>
                <td class="ts-whitespace-no-wrap ts-text-center">
                  <ts-currency-input :value="model.grand_total" class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;color:red" :currency="getCurrencySign(model.currency_id)"
                    :precision="getPrecision(model.currency_id)" :disabled="true" />
                </td>
                <td colspan="3"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </fieldset>
    <a-modal v-if="showForm" v-model="showForm" :title="$t('expensePosting.expItemLists')" centered :zIndex="1020"
      :footer="null" width="700px">
      <ExpItemList v-model="model" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ExpItemList from './exp-item-list'
import { Errors } from 'form-backend-validation'
import { isEmpty } from 'lodash'

export default {
  name: 'detail',
  props: ['value', 'validate'],
  components: {
    ExpItemList
  },
  data() {
    return {
      showForm: false,
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('expense/expensePosting', ['formViewDatas', 'edit_data']),
    advanceStatus() {
      return [
        {
          label: 'Processing',
          value: 1
        },
        {
          label: 'Reimbursed',
          value: 2
        }
      ]
    },
    expenseStatus() {
      if (this.model.expense_type == 0) {
        return [
          {
            label: 'Pending',
            value: 1
          },
          {
            label: 'Paid',
            value: 2
          },
        ]
      } else if (this.model.expense_type == 1) {
        return [
          {
            label: 'Pending',
            value: 1
          },
          {
            label: 'Claimed',
            value: 3
          }
        ]
      }
    },
    advance_amount() {
      if (this.formViewDatas['cashAdvances'] && this.model.advance_id) {
        const cashAdvances = this.formViewDatas['cashAdvances'].find(
          el => el.advance_id == this.model.advance_id
        )
        if (cashAdvances) {
          this.model.advance_amount =
            cashAdvances.amount_due +
            (this.edit_data ? this.edit_data.grand_total : 0)
          this.model.advance_status =
            cashAdvances.advance_status == 0 ? 1 : cashAdvances.advance_status
          return cashAdvances.advance_amount
        }
      }
      return null
    },
    amount_used() {
      if (this.formViewDatas['cashAdvances'] && this.model.advance_id) {
        const cashAdvances = this.formViewDatas['cashAdvances'].find(
          el => el.advance_id == this.model.advance_id
        )
        if (cashAdvances) {
          return !isEmpty(this.edit_data)
            ? cashAdvances.amount_used +
            this.model.grand_total -
            this.edit_data.grand_total
            : cashAdvances.amount_used + this.model.grand_total
        }
      }
      return null
    },
    amount_due() {
      return this.advance_amount - this.amount_used
    },
    expenseItems() {
      if (this.formViewDatas['expenseItems']) {
        return this.formViewDatas['expenseItems']
      }
      return []
    },
    employees() {
      if (this.formViewDatas['employees']) {
        return this.formViewDatas['employees'].map(el => ({
          value: el.employee_id,
          label: el.employee_name_en + '|' + el.employee_name_kh
        }))
      }
      return []
    },
    unitOfMeasures() {
      if (this.formViewDatas['unitOfMeasures']) {
        return this.formViewDatas['unitOfMeasures'].map(el => ({
          value: el.uom_id,
          label: el.uom_name_en,
          uom_cat_id: el.uom_cat_id,
          is_default: el.is_default,
          stockout_quantity: el.stockout_quantity
        }))
      }
      return []
    }
  },
  methods: {
    getExpenseItem(exp_id) {
      return this.expenseItems.find(el => el.exp_id == exp_id)
    },
    getProduct(detail) {
      if (this.formViewDatas['products']) {
        let product = this.formViewDatas['products'].find(
          el => el.product_id == detail.product_id
        )
        return product
      }
      return []
    },
    getImei(detail) {
      if (this.formViewDatas['serials']) {
        let serials = this.formViewDatas['serials'].find(
          el => el.serial_no == detail.serial_no
        )
        return serials
      }
      return []
    },
    getUnitOfMeasures(exp_id) {
      let item = this.expenseItems.find(el => el.exp_id == exp_id)
      if (item) {
        return this.unitOfMeasures.filter(
          el => el.uom_cat_id == item.uom_cat_id
        )
      }
      return null
    },
    addNewItem() {
      this.showForm = true
    },
    removeRow(detail) {
      this.model.details.splice(this.model.details.indexOf(detail), 1)
    },
    getCurrencySign(currency_id) {
      if (this.formViewDatas['currency']) {
        const currency = this.formViewDatas['currency'].find(
          el => el.currency_id == currency_id
        )

        return currency ? currency.currency_symbol : null
      }
      return '$'

    },
    getPrecision(currency_id) {
      if (this.formViewDatas['currency']) {
        const currency = this.formViewDatas['currency'].find(
          el => el.currency_id == currency_id
        )
        return currency ? currency.currency_rounding : null
      }
      return 2
    },
    calculate() {
      if (this.formViewDatas) {
        this.model.grand_total = 0
        let order = 1
        this.model.details.map(item => {
          item.input_total = item.input_unit_price * item.quantity
          item.total = item.input_total * item.fx_rate_ratio

          item.order = order++

          this.model.grand_total = this.model.grand_total + item.total
        })
      }
    },
    onChangeAdvanceStatus(value) {
      this.model.expense_status = this.model.advance_status == 1 ? 4 : 5
    }
  },
  watch: {
    'model.details': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style scoped>
.form-control {
  height: 32px;
}
</style>
<style>
.ant-input-group-addon .ant-select .ant-select-selection {
  margin: 0;
}

.ant-input-group .ant-input {
  height: 32px !important;
  text-align: right;
}
</style>
